"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPossiblyAliveOffer = exports.isFailFetchingReviews = exports.getSelectedIntegrationServices = exports.getPreviousBookings = exports.getOperatorOptions = exports.getOpenedOfferID = exports.getOpenedInModalByKey = exports.getIsShowBookingForOperatorForm = exports.getIsSetOpenedOfferID = exports.getIsEnabledSave2Order = exports.getIsEnabledOpenedOfferFeature = exports.getIsEnabledIntegrationServices = exports.getIsEnabledCopyURL2Buffer = exports.getIsEnabledCopy2Buffer = exports.getIsEnabledAdd2Basket = exports.getIntegrationServices = exports.getInitialPaymentType = exports.getInitialIsShowBookingForOperatorForm = exports.getInitialBookingCompany = exports.getFosterLinkOfOffer = exports.getCustomBookingTitleByOperator = exports.getCountries = exports.getBootstrapOffer = exports.getBootstrapHotel = exports.getBootstrapData = exports.getBookingOperator = exports.getBookingCompanies = exports.getActiveIntegrationServices = exports.getActiveFlights = void 0;
var _reselect = require("reselect");
var _connectedReactRouter = require("connected-react-router");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _constants = require("@otpusk/apisearch-toolbox/dist/offers/constants");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _book = require("../../../../routes/book");
var _external = require("../../../../../bus/external");
var _constants2 = require("../constants");
var _constants3 = require("./constants");
var _helpers = require("./helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var EMPTY_LIST = [];
var domain = function domain(_) {
  return _.offerDetails;
};
var getReviewsFetchingErrors = (0, _reselect.createSelector)(domain, R.prop('reviewsFecthingErrors'));
var getBootstrapData = exports.getBootstrapData = R.pipe(domain, R.prop('bootstrapData'));
var getOpenedInModalByKey = exports.getOpenedInModalByKey = (0, _reselect.createSelector)(getBootstrapData, R.prop('openedInModalByKey'));
var getIsShowBookingForOperatorForm = exports.getIsShowBookingForOperatorForm = (0, _reselect.createSelector)(domain, R.prop('isShowBookingForOperatorForm'));
var getActiveFlights = exports.getActiveFlights = R.pipe(domain, R.prop('activeFlights'));
var getInitialIsShowBookingForOperatorForm = exports.getInitialIsShowBookingForOperatorForm = (0, _reselect.createSelector)(_connectedReactRouter.getSearch, R.ifElse(Boolean, function (search) {
  return search.includes('shouldOpenBookingForm');
}, R.always(false)));
var getCountries = exports.getCountries = (0, _reselect.createSelector)(domain, R.prop('countries'));
var isFailFetchingReviews = exports.isFailFetchingReviews = function isFailFetchingReviews() {
  return (0, _reselect.createSelector)(getReviewsFetchingErrors, function (_, _ref) {
    var hotelID = _ref.hotelID;
    return hotelID;
  }, function (reviewsErrors, hotelID) {
    return Boolean(reviewsErrors[hotelID]);
  });
};
var offerSelector = (0, _selectors.getOffer)();
var hotelSelector = (0, _selectors2.getHotel)();
var getBootstrapOffer = exports.getBootstrapOffer = function getBootstrapOffer(state) {
  var _getBootstrapData = getBootstrapData(state),
    offerID = _getBootstrapData.offerID;
  return (0, _selectors.getActualizedOffer)()(state, {
    offerID: offerID
  }) || offerSelector(state, {
    offerID: offerID
  });
};
var getBootstrapHotel = exports.getBootstrapHotel = function getBootstrapHotel(state) {
  var _getBootstrapData2 = getBootstrapData(state),
    hotelID = _getBootstrapData2.hotelID;
  return hotelSelector(state, hotelID);
};
var getBookingOperator = exports.getBookingOperator = function getBookingOperator(state) {
  var offer = getBootstrapOffer(state);
  return (0, _external.getBookingOperatorById)(state, {
    operatorID: offer.operator
  });
};
var getInitialPaymentType = exports.getInitialPaymentType = R.pipe(getBookingOperator, R.pipe(R.propOr(EMPTY_LIST, 'paymentTypes'), R.head, R.prop('value')));
var getOptions = (0, _reselect.createSelector)(getBookingOperator, R.pipe(R.propOr(EMPTY_LIST, 'options'), R.filter(function (_ref2) {
  var type = _ref2.props.type;
  return R.includes(type, R.values(_constants2.OPTIONS_CONTROLS_TYPES));
})));
var getOperatorOptions = exports.getOperatorOptions = (0, _reselect.createSelector)(getOptions, getBootstrapHotel, function (options, hotel) {
  return R.filter(function (_ref3) {
    var countriesIds = _ref3.props.countriesIds;
    return R.isEmpty(countriesIds) || countriesIds.includes(hotel.country.id);
  }, options);
});
var getOfferActionsEnabled = R.pipe(domain, R.prop('offerActionsEnabled'));
var getIsEnabledAdd2Basket = exports.getIsEnabledAdd2Basket = R.pipe(getOfferActionsEnabled, R.prop(_constants3.OFFER_ACTIONS.ADD_TO_BASKET));
var getIsEnabledSave2Order = exports.getIsEnabledSave2Order = R.pipe(getOfferActionsEnabled, R.prop(_constants3.OFFER_ACTIONS.SAVE_TO_ORDER));
var getIsEnabledCopy2Buffer = exports.getIsEnabledCopy2Buffer = R.pipe(getOfferActionsEnabled, R.prop(_constants3.OFFER_ACTIONS.COPY_TO_BUFFER));
var getIsEnabledCopyURL2Buffer = exports.getIsEnabledCopyURL2Buffer = R.pipe(getOfferActionsEnabled, R.prop(_constants3.OFFER_ACTIONS.COPY_URL_TO_BUFFER));
var getOpenedOfferID = exports.getOpenedOfferID = R.pipe(_connectedReactRouter.getSearch, function (string) {
  return new URLSearchParams(string).get(_constants3.OPENED_OFFER_ID_PARAM_NAME);
});
var getIsSetOpenedOfferID = exports.getIsSetOpenedOfferID = R.pipe(getOpenedOfferID, Boolean);
var getIsEnabledOpenedOfferFeature = exports.getIsEnabledOpenedOfferFeature = R.pipe(_connectedReactRouter.getLocation, function (_ref4) {
  var pathname = _ref4.pathname;
  return pathname === _book.book.search;
});
var getFosterLinkOfOffer = exports.getFosterLinkOfOffer = R.pipe(domain, R.prop('fosterLinkOfOffer'));
var getPreviousBookings = exports.getPreviousBookings = R.pipe(domain, R.prop('previousBookings'));
var getBookingCompanies = exports.getBookingCompanies = R.pipe(domain, R.prop('bookingCompanies'));
var getInitialBookingCompany = exports.getInitialBookingCompany = R.pipe(getBookingCompanies, R.pipe(R.head, R.prop('value')));
var isPossiblyAliveOffer = exports.isPossiblyAliveOffer = R.pipe(_selectors.getOfferStatus, function (status) {
  return R.or(R.equals(_constants.ALIVE_OFFER_STATUS, status), R.equals(_constants.UNKNOWN_OFFER_STATUS, status));
});
var getIntegrationServices = exports.getIntegrationServices = R.pipe(domain, R.prop('integrationServices'));
var getActiveIntegrationServices = exports.getActiveIntegrationServices = R.pipe(domain, R.prop('activeIntegrationServices'));
var getSelectedIntegrationServices = exports.getSelectedIntegrationServices = (0, _reselect.createSelector)(getIntegrationServices, getActiveIntegrationServices, function (services, selectedServices) {
  return R.filter(function (_ref5) {
    var id = _ref5.id;
    return selectedServices[id];
  }, services);
});
var getIsEnabledIntegrationServices = exports.getIsEnabledIntegrationServices = function getIsEnabledIntegrationServices(state) {
  var offer = getBootstrapOffer(state);
  var _getBookingTypes = (0, _external.getBookingTypes)(state, {
      operatorID: offer.operator
    }),
    isBookingByOwn = _getBookingTypes.isBookingByOwn;
  return isBookingByOwn && (0, _helpers.getIsDateAfterTomorrow)(offer.date);
};
var getCustomBookingTitleByOperator = exports.getCustomBookingTitleByOperator = (0, _reselect.createSelector)([getBootstrapOffer, getBootstrapHotel, _external.getBookingOperatorById, function (state, _ref6) {
  var queryID = _ref6.queryID;
  return (0, _selectors3.getQueryParam)(state, {
    queryID: queryID,
    paramName: _fn.QUERY_PARAMS.CURRENCY
  });
}], function (offer, hotel, _ref7, currency) {
  var customBookingTriggerTitle = _ref7.customBookingTriggerTitle;
  if (!customBookingTriggerTitle) {
    return null;
  }
  var isPromotionalBookingOffer = (0, _helpers.getIsPromotionalBookingOffer)(offer, hotel, currency);
  return isPromotionalBookingOffer ? customBookingTriggerTitle : null;
});